import { createRouter, createWebHashHistory } from 'vue-router'
import { platformDetector } from '@/utils/platform.js'
import { initWechat, isWechatReady } from '@/utils/wechat.js'

// 路由配置
const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/chat'
  },
  {
    path: '/form',
    name: 'Form',
    component: () => import('@/views/FormView.vue'),
    meta: {
      title: '用户信息填写',
      requiresAuth: false
    }
  },
  {
    path: '/chat',
    name: 'Chat',
    component: () => import('@/views/ChatView.vue'),
    meta: {
      title: 'AI问卷对话',
      requiresAuth: false
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    redirect: '/chat'
  }
]

// 创建路由实例
// 使用 Hash 模式以获得更好的微信兼容性：
// 1. 微信签名只看 # 前的URL，避免路由跳转导致签名失效
// 2. 无需服务器配置，刷新不会404
// 3. 微信分享参数不影响路由
const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// 全局前置守卫
router.beforeEach(async (to, from, next) => {
  // 设置页面标题
  if (to.meta?.title) {
    document.title = `${to.meta.title} - 睡眠问诊小助手`
  }
  
  // 如果进入Chat页面且在微信环境中，确保微信SDK已初始化
  if (to.name === 'Chat' && platformDetector.isWeChat()) {
    if (!isWechatReady()) {
      // warn('⚠️ 微信SDK未就绪，尝试初始化...')
      try {
        const success = await initWechat()
        if (success) {
          // info('✅ 微信SDK初始化成功，继续导航')
        } else {
          // warn('⚠️ 微信SDK初始化失败，但继续导航（录音功能可能不可用）')
        }
      } catch (error) {
        // error('❌ 微信SDK初始化异常:', error)
      }
    } else {
      // debug('✅ 微信SDK已就绪')
    }
  }
  
  next()
})

// 全局后置守卫
router.afterEach((to, from) => {
  console.log(`路由切换: ${from.name} -> ${to.name}`)
})

export default router
